import React, {useContext} from "react";
import {CustomerTypeContext, isCustomerCompany} from "../../../context/customer-type-context";
import FormatUtils from "../../../utils/FormatUtils";
import LabelWithInfo from "../../../components/LabelWithInfo/LabelWithInfo";

const DRIVE_PLUS_INFO_CONTENT = `
    <p>Pakiet korzyści sprawia, że finansowanie samochodu to nie tylko atrakcyjna rata.
    Zyskujesz również rozwiązania, które dają większy spokój, wygodę i poczucie kontroli
    nad kosztami przez cały okres umowy.</p>
    <p><a href="/pakiet-korzysci">Sprawdź, co zyskujesz z pakietem korzyści</a></p>
    <p><strong>4 korzyści, które pozwolą Ci zaoszczędzić nawet kilka tysięcy złotych
    w trakcie trwania umowy:</strong></p>
    <ul>
        <li><a href="/assistance">Assistance</a></li>
        <li><a href="/usluga-gps">Usługa GPS</a></li>
        <li><a href="/rabatowa-karta-serwisowa">Rabatowa karta serwisowa</a></li>
        <li><a href="/asysta-szkodowa">Asysta Szkodowa</a></li>
    </ul>
`;

function DrivePlusCheckbox({installment}) {
    const customerContext = useContext(CustomerTypeContext);
    const isCompany = isCustomerCompany(customerContext);

    if (installment == null) return null;

    return (
        <div className="calc__form-item">
            <label className="search-checkbox-row calc__ins-row calc__ins-row--ocac">
                <input
                    type="checkbox"
                    checked={true}
                    disabled={true}
                    className="calc__insurance-ocac-input"
                />
                <span className="calc__ins-label">
                    <LabelWithInfo
                        infoCode="pakiet-korzysci"
                        title="Pakiet korzyści"
                        content={DRIVE_PLUS_INFO_CONTENT}
                    />
                </span>
                <span className="calc__ins-price">
                    {FormatUtils.formatMoney(installment)}/mies.
                </span>
            </label>
        </div>
    );
}

export default DrivePlusCheckbox;
